<template>
    <div class="in-one">
        <ContentBox
            title="区县乡镇配送无盲点覆盖"
            text="全国仓配网络覆盖及自主研发为家电、家居（含建材）、电商平台、快消行业客户提供优质、有竞争力的仓装运配一体化、全方位、全流程的解决方案平台"
        >
            <div class="top">
                <viewer v-if="COMMON.isMobile">
                    <img src="../../images/picture/product_cpyt_lct.png">
                </viewer>
                <img class="top-pic" src="../../images/picture/product_cpyt_lct.png" v-else>
            </div>
        </ContentBox>
        <div class="middle">
            <ContentBox title="专业配送服务为您提供专业的解决方案">
                <div class="item-wrap">
                    <div class="item">
                        <img class="item-icon" src="../../images/icon/jiqixuexi.png">
                        <div>
                            <div class="item-title">省内直配</div>
                            <p class="item-content">省内乡镇门店直接送达</p>
                        </div>
                    </div>
                    <div class="item">
                        <img class="item-icon" src="../../images/icon/wangluotuopu.png">
                        <div>
                            <div class="item-title">同城配送</div>
                            <p class="item-content">同城门店、商超、卖场24H内按约准时送达</p>
                        </div>
                    </div>
                    <div class="item">
                        <img class="item-icon" src="../../images/icon/line_wangluotuopu.png">
                        <div>
                            <div class="item-title">增值服务</div>
                            <p class="item-content">提供货物险、短信提醒、贴码服务、库存风险透视等增值服务</p>
                        </div>
                    </div>
                    <div class="item">
                        <img class="item-icon" src="../../images/icon/peizhi.png">
                        <div>
                            <div class="item-title">B2C配装</div>
                            <p class="item-content">大件最后一公里送装一体服务</p>
                        </div>
                    </div>
                </div>
            </ContentBox>
        </div>
        <ContentBox title="运配能力" text="行业领先的路运能力，提供安全省心的运输方案">
            <div class="bottom">
                <div class="bottom-content">
                    <div class="left">
                        <div
                            :class="{tab: true, active: current === 'tab0'}"
                            @click="showTab('tab0')"
                        >仓储管理+干线运输</div>
                        <div
                            :class="{tab: true, 'tab-space': true, active: current === 'tab1'}"
                            @click="showTab('tab1')"
                        >仓储管理+同城配送</div>
                    </div>
                    <div class="right">
                        <div class="arrow" :class="[current]"></div>
                        <div :class="{'content': true, hide: current !== 'tab0'}" v-if="!isMobile">
                            <div class="line">
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_pszx.png">
                                    <div class="item-title">区域配送中心</div>
                                    <div class="item-content">
                                        <span class="num">117</span>
                                        <span class="unit">个</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_kedy.png">
                                    <div class="item-title">可调用车辆</div>
                                    <div class="item-content">
                                        <span class="num">140000</span>
                                        <span class="unit">余辆</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_zt.png">
                                    <div class="item-title">在途车辆</div>
                                    <div class="item-content">
                                        <span class="num">10000</span>
                                        <span class="unit">余辆</span>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_wl.png">
                                    <div class="item-title">运营网络</div>
                                    <div class="item-content">
                                        <span class="num">13000</span>
                                        <span class="unit">余条线路</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_ps.png">
                                    <div class="item-title">年均配送里程数</div>
                                    <div class="item-content">
                                        <span class="num">1亿</span>
                                        <span class="unit">公里</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_ys.png">
                                    <div class="item-title">年均运输里程数约</div>
                                    <div class="item-content">
                                        <span class="num">3.6亿</span>
                                        <span class="unit">公里</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="{'content': true, hide: current !== 'tab0'}" v-else>
                            <div class="line">
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_pszx.png">
                                    <div>
                                        <div class="item-content">
                                            <span class="num">118</span>
                                            <span class="unit">个</span>
                                        </div>
                                        <div class="item-title">区域配送中心</div>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_kedy.png">
                                    <div>
                                        <div class="item-content">
                                            <span class="num">140000</span>
                                            <span class="unit">余辆</span>
                                        </div>
                                        <div class="item-title">可调用车辆</div>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_zt.png">
                                    <div>
                                        <div class="item-content">
                                            <span class="num">10000</span>
                                            <span class="unit">余辆</span>
                                        </div>
                                        <div class="item-title">在途车辆</div>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_wl.png">
                                    <div>
                                        <div class="item-content">
                                            <span class="num">13000</span>
                                            <span class="unit">余条线路</span>
                                        </div>
                                        <div class="item-title">运营网络</div>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_ps.png">
                                    <div>
                                        <div class="item-content">
                                            <span class="num">1亿</span>
                                            <span class="unit">公里</span>
                                        </div>
                                        <div class="item-title">年均配送里程数</div>
                                    </div>
                                </div>
                                <div class="item">
                                    <img class="item-icon" src="../../images/icon/cpyt_ys.png">
                                    <div>
                                        <div class="item-content">
                                            <span class="num">3.6亿</span>
                                            <span class="unit">公里</span>
                                        </div>
                                        <div class="item-title">年均运输里程数约</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            :class="{'content bg': true, 'left-align': true, hide: current !== 'tab1'}"
                        >
                            <p>
                                <span class="text-point"></span>
                                <span>117个区域配送中心所在城市、37个服务中心所在城市，24小时到达</span>
                            </p>
                            <p class="text-space">
                                <span class="text-point"></span>
                                <span>每个配送中心均有2000+线路</span>
                            </p>
                            <p class="text-space">
                                <span class="text-point"></span>
                                <span>全省80%以上乡镇区域，48小时内到达</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ContentBox>
    </div>
</template>

<script>
import ContentBox from '../common/content-box';
export default {
    metaInfo: {
        title: '安得智联-仓配一体化优势|供应链服务',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联仓配一体化优势,供应链服务'
        },{                 // set meta
            name: 'description',
            content: '安得智联仓配一体化优势,致力于为客户提供端到端数智化供应链服务解决方案.'
        }]
    },
    name: 'in-one',
    data() {
        return {
            current: 'tab0',
            isMobile: this.COMMON.isMobile
        };
    },
    methods: {
        showTab(tab) {
            this.current = tab;
        }
    },
    components: {
        ContentBox
    }
};
</script>

<style lang="less">
.in-one {
    img {
        max-width: 100%;
    }
    .sub-content {
        font-size: 16px;
        margin-bottom: 0.15rem;
        color: #666666;
    }
    .top {
        margin: 0 auto 0.75rem auto;
        text-align: center;
    }
    .middle {
        padding: 0 0.75rem 0.75rem;
        text-align: center;
        background-color: #fafafa;
        .item-wrap {
            display: flex;
            flex-direction: column;
            align-items: top;
        }
        .item {
            width: 25%;
            text-align: center;
            padding: 0 0.5rem;
        }
        .item-icon {
            width: 0.63rem;
            height: 0.67rem;
            background-size: 100% 100%;
            margin: 0 auto;
        }
        .item-title {
            font-size: 20px;
            color: #333333;
            margin-top: 0.5rem;
        }
        .item-content {
            color: #666666;
            margin-top: 1em;
        }
    }
    .bottom {
        margin: 0 auto 0.75rem auto;
        text-align: center;
        .bottom-content {
            height: 5.2rem;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .left {
            width: 25%;
            height: 100%;
        }
        .tab {
            margin-top: 0.65rem;
            width: 100%;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 20px;
            box-shadow: 0 0 0.3rem #dfefff;
            cursor: pointer;
        }
        .tab-space {
            margin-top: 0.4rem;
        }
        .active {
            background-color: #007eff;
            color: #ffffff;
        }
        .right {
            width: 75%;
            height: 100%;
            border: 0.01rem solid #f6f6f6;
            position: relative;
        }
        .arrow {
            width: 0.1rem;
            height: 0.1rem;
            background-color: #ffffff;
            position: absolute;
            left: -0.06rem;
            z-index: 2;
            transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            -o-transform: rotate(45deg);
        }
        .tab0 {
            top: 1rem;
        }
        .tab1 {
            top: 2.2rem;
        }
        .hide {
            display: none;
        }
        .content {
            width: 100%;
            height: 100%;
            background: url("../../images/picture/yunpei_canggan.png");
            padding: 0.8rem;
            box-sizing: border-box;
            .line {
                width: 100%;
                height: 50%;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
        .item {
            width: 33.3%;
            height: 100%;
            text-align: center;
        }
        .item-icon {
            width: 0.6rem;
            height: 0.6rem;
            background-size: 100% 100%;
            margin: 0 auto;
        }
        .item-title {
            color: #333333;
            margin-top: 1em;
        }
        .item-content {
            margin-top: 0.5em;
        }
        .num {
            font-size: 24px;
            color: #333333;
        }
        .unit {
            color: #333333;
        }
        .text-space {
            margin-top: 0.4rem;
        }
        .bg {
            background: url("../../images/picture/cpyt_pc_bg.png");
        }
        .left-align {
            text-align: left !important;
        }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .in-one .bottom {
        .num {
            font-size: 20px;
        }
        .tab {
            font-size: 18px;
        }
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .in-one .bottom {
        .num {
            font-size: 18px;
        }
        .tab {
            font-size: 16px;
        }
    }
}

@media screen and (max-width: 480px) {
    .in-one {
        .sub-content {
            font-size: 12px;
            margin-bottom: 0.1rem;
            text-align: center;
            color: #999999;
        }
        .top {
            margin: 0 auto 0.1rem auto;
            padding: 0.15rem;
            box-sizing: border-box;
            .top-pic {
                margin: 0.2rem auto;
            }
        }
        .middle {
            padding: 0.15rem;
            .item-wrap {
                flex-wrap: wrap;
                margin-top: 0.15rem;
                height: auto;
            }
            .item {
                width: 100%;
                text-align: left;
                padding: 0.15rem 0.05rem;
                min-width: 1rem;
                display: flex;
                border-bottom: solid #e6e6e6 1px;
            }
            .item-icon {
                width: 0.35rem;
                height: 0.36rem;
                margin: 0.1rem 0.15rem;
            }
            .item-title {
                margin: 0.05rem 0 0.05rem 0;
                font-size: 14px;
            }
            .item-content {
                font-size: 12px;
                text-align: left;
                margin: 0;
                color: #999999;
            }
        }
        .bottom {
            margin: 0.3rem auto 0 auto;
            text-align: center;
            .bottom-content {
                margin-top: 0.3rem;
                height: auto;
                display: block;
                align-items: center;
            }
            .left {
                width: auto;
                height: auto;
                display: flex;
                padding-bottom: 0.17rem;
                border-bottom: 1px solid #e6e6e6;
                margin: 0 0.15rem;
            }
            .tab {
                margin-top: 0;
                width: 100%;
                height: 0.2rem;
                line-height: 0.2rem;
                text-align: center;
                font-size: 12px;
                box-shadow: 0 0;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }
            .tab-space {
                margin-top: 0;
            }
            .active {
                background-color: #ffffff;
                color: #007eff;
            }
            .right {
                width: 100%;
                height: 100%;
                border: 0;
                position: relative;
            }
            .arrow {
                width: 0.1rem;
                height: 0.1rem;
                background-color: #ffffff;
                position: absolute;
                top: -0.07rem;
                z-index: 2;
                transform: rotate(45deg);
                border-top: #e6e6e6 solid 1px;
                border-left: #e6e6e6 solid 1px;
            }
            .tab0 {
                left: 26%;
            }
            .tab1 {
                left: 71%;
            }
            .hide {
                display: none;
            }
            .content {
                width: 100%;
                height: 100%;
                background: url("../../images/picture/yunpei_canggan.png")
                    center;
                padding: 0.5rem 0.25rem;
                box-sizing: border-box;
                font-size: 12px;
                line-height: 0.2rem;
                .line {
                    width: 100%;
                    height: 1rem;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
            }
            .item {
                width: 33.3%;
                height: 100%;
                text-align: center;
                flex: 1;
                display: flex;
            }
            .item:first-child {
                margin-right: 0.1rem;
            }
            .item-icon {
                width: 0.3rem;
                height: 0.3rem;
                background-size: 100% 100%;
                margin: 0.1rem 0.1rem 0 0;
            }
            .item-title {
                font-size: 12px;
                color: #999999;
                margin-top: 0.1rem;
            }
            .item-content {
                margin-top: 0;
            }
            .num {
                font-size: 16px;
                color: #333333;
            }
            .unit {
                font-size: 12px;
                color: #333333;
            }
            .text-space {
                margin-top: 0.2rem;
            }
            .text-point {
                width: 0.06rem;
                height: 0.06rem;
                background: #ff8b00;
                border-radius: 50%;
                display: inline-block;
                margin: 0.02rem 0.1rem;
            }
            .bg {
                background: url("../../images/picture/cpyt_yd_bg.png") no-repeat;
                background-size: contain;
                background-position-y: 1rem;
                height: 3.6rem;
            }
            .left-align {
                text-align: left !important;
            }
        }
    }
}
</style>